import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { ZoomIn, ZoomOut } from '@material-ui/icons';
import React, { useCallback } from 'react';
import { useLocalization, useViewerState } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {},
    icon: {}
  });
});

/**
 * Document widget component for modifying the zoom mode / level
 */
export const ZoomInOutWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  const zoomIn = useCallback(() => {
    viewerState.updateState({
      zoomLevel: viewerState.zoomLevel + 1
    });
  }, [viewerState]);
  const zoomOut = useCallback(() => {
    viewerState.updateState({
      zoomLevel: viewerState.zoomLevel - 1
    });
  }, [viewerState]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.iconButton,
    color: "inherit",
    onClick: zoomIn,
    title: localization.zoomIn,
    disabled: viewerState.zoomLevel >= 13
  }, /*#__PURE__*/React.createElement(ZoomIn, {
    className: classes.icon
  })), /*#__PURE__*/React.createElement(IconButton, {
    className: classes.iconButton,
    color: "inherit",
    onClick: zoomOut,
    title: localization.zoomOut,
    disabled: viewerState.zoomLevel <= -7
  }, /*#__PURE__*/React.createElement(ZoomOut, {
    className: classes.icon
  })));
};
//# sourceMappingURL=zoom-in-out.js.map